import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Spin} from 'antd'
import {addZeroes, getCurrencySymbol} from '@/utils'
import {Button} from '@/components'
import {urls} from '@/constants/urls'
import {EcospendBackLink, EcospendBankBlock, EcospendBlock, EcospendText} from '..'
import {EcospendPayeeBlock} from '../EcospendPayeeBlock'
import {EcospendConsentPageProps} from './props'
import styles from './EcospendConsentPage.scss'

export const EcospendConsentPage = observer((props: EcospendConsentPageProps) => {
    const { t } = useTranslation()
    const {store} = props
    const amount = store.amount
    const {currency, invoiceId} = store.currentPayment

    return <Spin spinning={store.isPaymentProcessing}>
        <>
            <EcospendBackLink
                onClick={() => store.back()}
            >
                {t('EcospendConsentPage.back')}
            </EcospendBackLink>

            <div className={styles.amountWrapper}>
                <span className={styles.currency}>{currency ? getCurrencySymbol(currency) : ' - '}</span>
                <span className={styles.amount}>{amount ? addZeroes(amount) : ' - '}</span>
            </div>

            <EcospendBankBlock
                friendlyName={store.selectedBank.friendly_name}
                invoiceId={invoiceId}
                amount={amount}
                className={styles.block}
            />

            <EcospendPayeeBlock payee={store.payee} className={styles.block}/>

            <EcospendBlock className={styles.largeBlock}>
                <EcospendText className={styles.infoText}>{t('EcospendConsentPage.infoText')}</EcospendText>

                <EcospendText className={styles.continueText}>
                    <Trans
                        i18nKey='EcospendConsentPage.privacyPolicyText'
                        components={[
                            <a key='terms' href={urls.termsUse} target="_blank" rel="noreferrer" />,
                            <a key='privacy' href={urls.privacyPolicy} target="_blank" rel="noreferrer"/>
                        ]}
                    />
                </EcospendText>

                <div className={styles.buttons}>
                    <Button type={'link'} onClick={() => store.cancel()}
                            className={styles.cancel}>{t('EcospendConsentPage.cancel')}</Button>
                    <Button type={'primary'} className={styles.continueButton}
                            onClick={() => store.openPopapWindow()}>{t('EcospendConsentPage.continue')}</Button>
                </div>

                <EcospendText className={styles.smalltext}>{t('EcospendConsentPage.permissionText')}</EcospendText>
            </EcospendBlock>

            <EcospendText
                className={styles.footertext}
            >
                <Trans
                    i18nKey='Ecospend.footerText'
                    components={{ a: <a href={'https://register.fca.org.uk/s/firm?id=0010X00004KSo9HQAT'} target="_blank" rel="noreferrer" /> }}
                />
            </EcospendText>
        </>
    </Spin>
})
